import Home from './main/home';
import PublicInformation from './main/myAccount/publicInformation';
import PrivateInformation from './main/myAccount/privateInformation';
import WebsiteName from './main/myAccount/myWebsite';
import OrderHistory from './main/orders/order';
import Membership from './main/myAccount/membership';
import iWallet from './main/iWallet/iWallet';
import PlacementPreference from './main/myTeam/placementPreference';
import DualTeamPlacementTree from './main/myTeam/binaryPlacementTree';
import SponsorTree from './main/myTeam/sponsorTree';
import BecomeanAffiliate from './main/becomeAnAffiliate';
import Leads from './main/projects/projectList';
import Calendar from './main/calendar/calendar';
import PersonallySponsored from './main/personallySponsored/personallySponsored';
import DualTeamBonus from './main/dualTeamBonusCommissions/dualTeamBonusCommission';
import DualTeamBonusVolume from './main/dualTeamBonusVolumes/dualTeamBonusVolume';
import MySponsor from './main/myTeam/sponsorInfo';
import Rewards from './main/rewards/rewards';
import AventiTravel from './main/travelVertex/travelVertex';
import RippleSecure from './main/rippleSecureSignup/rippleSecureSignup'
import AffiliateLeads from './main/affiliateProjects/affiliateProjectsList';
import Omni from './main/omni/omni';
import BNBWallet  from './main/publicWalletAddress/evmWallet';

const componentMap = {
  Home,
  PublicInformation,
  PrivateInformation,
  WebsiteName,
  OrderHistory,
  Membership,
  iWallet,
  PlacementPreference,
  DualTeamPlacementTree,
  SponsorTree,
  BecomeanAffiliate,
  Leads,
  Calendar,
  PersonallySponsored,
  DualTeamBonus,
  DualTeamBonusVolume,
  MySponsor,
  Rewards,
  AventiTravel,
  AffiliateLeads,
  RippleSecure,
  Omni,
  BNBWallet,
  // Add other dynamic components here
};

export default componentMap;